export default __webpack_public_path__ + "images/DisCover.8a9a1b73b3823ddf7d9bd754e70e5d04.svg";